// extracted by mini-css-extract-plugin
module.exports = {"productDiv":"SolutionDetail_productDiv__1JXvw","productTitleFont":"SolutionDetail_productTitleFont__2awBs","productFont":"SolutionDetail_productFont__1HQwT"};